import { CANVAS_OBJECT_TYPE_PREFIX } from '../constants';

export const makeApplianceName = (appliance: { id: string }) =>
  `${CANVAS_OBJECT_TYPE_PREFIX.APPLIANCE}_${appliance.id}`;

export const isEqApplianceId =
  (applianceId?: string) => (appliance: { id: string }) =>
    !!applianceId && makeApplianceName(appliance) === applianceId;
